export default "__VITE_ASSET__2b212ac1__"